import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ImportWizardComponent } from './import-wizard.component';
//import { StepTemplateDownloadComponent } from './steps/step-template-download.component';
import { StepSmartImportComponent } from './steps/step-smart-import.component';
import { AgGridModule } from 'ag-grid-angular';
import { EmployeesImportComponent } from './steps/employees-import.component';
import { CustomersTanksImportComponent } from './steps/customers-tanks-import.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ImportWizardComponent,
    //StepTemplateDownloadComponent,
    StepSmartImportComponent,
    EmployeesImportComponent,
    CustomersTanksImportComponent
  ],
  imports: [
    CommonModule,
    NgbModalModule,
    AgGridModule,
    FormsModule
  ],
  exports: [
    ImportWizardComponent
  ]
})
export class ImportWizardModule {}
